<template>
  <div class="view-start">
    <div class="square__wrapper">
      <div class="square__line">
        <div class="square__item" v-for="index in 4" :key="index"></div>
      </div>
      <div class="square__line">
        <div class="square__item" v-for="index in 4" :key="index"></div>
      </div>
    </div>
    <div class="content">
      <div class="heading">
        <div class="heading__title">
          <span class="title">Reliez</span>
        </div>
        <div class="heading__subtitle">
          <span class="subtitle">Les acteurs</span>
        </div>
      </div>
    </div>
    <Nav :buttons="buttons" text="Pour commencer, appuyez sur « Début »"/>
  </div>
</template>

<script>
  import Nav from '@/components/partials/Nav'

  import gsap from 'gsap'

  let tl = {}

  const heading = [{
    title: 'Reliez',
    subtitle: 'Les acteurs',
    instruction: 'Pour commencer, appuyez sur « Début »'
  }, {
    title: 'Link',
    subtitle: 'The players',
    instruction: 'To begin, press « Start »'
  }, {
    title: 'Conecta',
    subtitle: 'a los actores',
    instruction: 'Para comenzar, presione « Inicio »'
  }]

  export default {
    name: 'Start',
    components: {
      Nav
    },
    data() {
      return {
        buttons: [{
          label: 'Début',
          to: 'introduction',
          language: 'fr'
        }, {
          label: 'Start',
          to: 'introduction',
          language: 'en'
        }, {
          label: 'Inicio',
          to: 'introduction',
          language: 'es'
        }]
      }
    },
    methods: {
      animateHeading() {
        const $title = document.getElementsByClassName('title')
        const $subtitle = document.getElementsByClassName('subtitle')
        const $instruction = document.getElementsByClassName('nav__text')

        let index = 1

        tl = gsap.timeline({
          paused: true,
          repeat: -1,
          delay: 5,
          repeatDelay: 5,
          onRepeat: () => {
            index += 1
            if (index > heading.length - 1) {
              index = 0
            }
          }
        })

        tl.to($title, {
          y: '100%',
          duration: 0.6,
          ease: 'power4.in',
          onComplete: () => {
            $title[0].innerText = heading[index].title
          }
        }, 0)

        tl.to($subtitle, {
          y: '-120%',
          duration: 0.6,
          ease: 'power4.in',
          onComplete: () => {
            $subtitle[0].innerText = heading[index].subtitle
          }
        }, 0)

        tl.to($instruction, {
          autoAlpha: 0,
          duration: 0.6,
          ease: 'power4.in',
          onComplete: () => {
            $instruction[0].innerText = heading[index].instruction
          }
        }, 0)

        tl.to($title, {
          y: '0%',
          duration: 0.6,
          ease: 'power4.out'
        }, 0.7)

        tl.to($subtitle, {
          y: '0%',
          duration: 0.6,
          ease: 'power4.out'
        }, 0.7)

        tl.to($instruction, {
          autoAlpha: 1,
          duration: 0.6,
          ease: 'power4.out'
        }, 0.7)

        tl.play()
      }
    },
    mounted() {
      this.animateHeading()

      setTimeout(() => {
        this.loadFxs()
      }, 800)
    },
    beforeDestroy() {
      if (Object.keys(tl).length > 0) {
        tl.kill()
      }
    }
  }
</script>

<style lang="scss">
  .view-start {
    height: 100%;

    .square {
      &__wrapper {
        @include fullcover;

        width: 100%;
        height: 100%;

        z-index: 1;
      }
      &__line {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        height: 50%;
        overflow: hidden;

        &:first-child {
          .square__item {
            &:first-child {
              background-color: #960F20;

              &::before {
                clip-path: polygon(100% 0, 100% 100%, 0 100%);
                background-color: #CB292F;
              }
            }
            &:nth-child(2) {
              background-color: #AD2B2B;

              &::before {
                clip-path: polygon(0 0, 100% 100%, 0 100%);
                background-color:#960F20;
              }
            }
            &:nth-child(3) {
              background-color: $pink;

              &::before {
                clip-path: polygon(0 0, 100% 0, 0 100%);
                background-color: #D54044;
              }
            }
            &:nth-child(4) {
              background-color: #D54044;

              &::before {
                clip-path: polygon(0 0, 100% 100%, 0 100%);
                background-color: $pink;
              }
            }
          }
        }
        &:last-child {
          .square__item {
            &:nth-child(1) {
              background-color: #610D1A;

              &::before {
                clip-path: polygon(0 0, 100% 0, 100% 100%);
                background-color: #7C0E1D;
              }
            }
            &:nth-child(2) {
              background-color: #702C37;

              &::before {
                clip-path: polygon(0 0, 100% 0, 0 100%);
                background-color:#622029;
              }
            }
            &:nth-child(3) {
              background-color:#A32D34;

              &::before {
                clip-path: polygon(0 0, 100% 100%, 0 100%);
                background-color:#960F20;
              }
            }
            &:nth-child(4) {
              background-color: $pink;

              &::before {
                clip-path: polygon(0 0, 100% 0, 0 100%);
                background-color: $pink;
              }
            }
          }
        }
      }
      &__item {
        position: relative;
        overflow: hidden;
        flex: 0 1 auto;
        min-width: 30%;
        height: 100%;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }

    .content {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 50%;

      color: $white;

      z-index: 2;
    }

    .heading {
      margin-left: 35%;

      &__title {
        position: relative;
        font-size: 150px;
        line-height: 1;
        overflow: hidden;

        .title {
          display: block;
        }
      }
      &__subtitle {
        position: relative;
        font-size: 70px;
        line-height: 1.3;
        overflow: hidden;

        .subtitle {
          display: block;
        }
      }
    }

    // Queries
    @include mq($and: '(max-height: 800px)') {
      .content {
        top: 35%;
      }
    }

    @include mq($until: wide, $and: '(orientation: landscape)') {
      .content {
        top: 50%;
        height: auto;
        transform: translateY(-50%);
      }
      .heading {
        margin-left: 45%;

        &__title {
          font-size: 90px;
        }
        &__subtitle {
          font-size: 50px;
        }
      }

      .square {
        &__line {
          height: 100%;

          .square__item {
            width: 50%;

            &:nth-child(3),
            &:nth-child(4) {
              display: none;
            }
          }

          &:last-child {
            display: none;
          }
        }
      }
    }
  }
</style>
